import { render, staticRenderFns } from "./branchesMain.vue?vue&type=template&id=4accdb1a&scoped=true&"
import script from "./branchesMain.vue?vue&type=script&lang=js&"
export * from "./branchesMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4accdb1a",
  null
  
)

export default component.exports